<template>
  <b-col md="6">
    <div class="d-flex mr-5 align-items-center h-100 my-3">
      <img :src="getImgUrl(imgSrc)" class="image-width" />
      <span class="ml-4 font-weight-bold">{{ text }}</span>
    </div>
  </b-col>
</template>

<script>
import ImageUrlMixin from '@/mixins/ImageUrlMixin';

export default {
  name: 'ImageText',
  mixins: [ImageUrlMixin],
  props: {
    imgSrc: String,
    text: String,
  },
};
</script>

<style scoped>
.image-width{
  width: 45px;
}
</style>
